(function () {
  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
  }

  document.addEventListener('shopify:section:load', function () {
    swiperInit();
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.product-section .js-media-list').forEach(function (el) {
        if (el.swiper) el.swiper.destroy();
      });
      document.querySelectorAll('.product-section .js-media-sublist').forEach(function (el) {
        if (el.swiper) el.swiper.destroy();
      });
      swiperInit();
    }, 150);
  });

  swiperInit();
})();
